export default __webpack_public_path__ + "static/media/Path3441.49880476.svg";